<div *ngIf="productVariantService.activeItem">
  <mat-horizontal-stepper #stepper
    [linear]="true"
    [selectedIndex]="2"
    labelPosition="bottom"
    class="stepper-container stepper-disabled-steps"
    >
    <!-- Step 1: visible, not clickable -->
    <mat-step [editable]="false" [completed]="true">
      <ng-template matStepLabel>Grunddaten</ng-template>
      <div class="step-disabled-info">Dieser Schritt ist deaktiviert.</div>
    </mat-step>

    <!-- Step 2: visible, not clickable -->
    <mat-step [editable]="false" [completed]="true">
      <ng-template matStepLabel>Gallerie & Dateien</ng-template>
      <div class="step-disabled-info">Dieser Schritt ist deaktiviert.</div>
    </mat-step>

    <mat-step [completed]="isVariantVersionStepComplete()">
      <ng-template matStepLabel>Variante bearbeiten</ng-template>
      <div class="form-header">
        <h1>{{ formTitle }}</h1>
        <div></div>
        <div></div>
        <button matButton="elevated" color="accent"
          (click)="openProductDetailsPageDialog('Produktübersicht')"
          [disabled]="!isVariantVersionStepComplete()">
          <mat-icon>crop_free</mat-icon>Vorschau
        </button>
      </div>
      <div>
        <form #form="ngForm">
          <mat-form-field class="variant-name-field">
            <mat-label>Variantenname</mat-label>
            <input matInput [(ngModel)]="variantEditName" name="variantName" required
              [value]="variantEdit.name" #variantNameCtrl="ngModel" [errorStateMatcher]="variantNameErrorStateMatcher"
              maxlength="161" minlength="2" [ngModelOptions]="{ updateOn: 'change' }" />
            <mat-error>
              {{ utilService.getErrorMessage(variantNameCtrl, {fieldName: 'Varianten', includeMinLength: true}) }}
            </mat-error>
          </mat-form-field>
          <!-- <mat-form-field class="edit-feature-description">
            <!-- <mat-form-field class="edit-feature-description">
                <textarea
                    matInput
                    placeholder="Kommentar (intern)"
                    [(ngModel)]="variantEditComment"
                    name="comment"
                    [value]="variantEdit.comment"
                ></textarea>
            </mat-form-field> -->
          <app-text-editor [(editorText)]="variantEditDescription"
            (textValidityChange)="onDescriptionValidityChange($event)"></app-text-editor>
          <div class="mini-grid-buttons">
            <span class="info-txt">*Pflichtfeld</span>
            <button matButton="elevated" color="warn" (click)="cancelVariantEdit()" style="margin-top: 1vw;">
              Abbrechen
            </button>
            <div></div>
            <div></div>
            <button matButton="elevated" class="green-confirm" [disabled]="!isVariantVersionStepComplete()" (click)="stepper.selectedIndex = 4"
              style="margin-top: 1vw;">Weiter</button>
          </div>

        </form>
      </div>
    </mat-step>

    <!-- Step 4: visible, not clickable -->
    <mat-step [editable]="false" [completed]="true">
      <ng-template matStepLabel>Übergeordnete Auswahlkriterien</ng-template>
      <div class="step-disabled-info">Dieser Schritt ist deaktiviert.</div>
    </mat-step>

    <mat-step>
      <ng-template matStepLabel>Zusammenfassung</ng-template>

      <div class="form-header">
        <h1>{{ formTitle }}</h1>
        <div></div>
        <button id="savebtn" matButton="elevated" color="accent" (click)="editVariant()"
          [disabled]="form.invalid || !isDescriptionValid">
          Speichern
        </button>
        <button matButton="elevated" color="accent"
          (click)="openProductDetailsPageDialog('Produktübersicht')">
          <mat-icon>crop_free</mat-icon>Vorschau
        </button>

      </div>

      <p class="info-text"><em>Bitte drücken Sie den Vorschau-Button um die Änderungen zu prüfen.</em></p>

      <div class="mini-grid-buttons">
        <button matButton="elevated" color="warn" (click)="cancelVariantEdit()" style="margin-top: 1vw;">
          Abbrechen
        </button>
        <div></div>
        <div></div>
        <button matButton="elevated" class="green-confirm" style="margin-top: 1vw;"
          (click)="stepper.selectedIndex = 2">Zurück</button>
      </div>
    </mat-step>
  </mat-horizontal-stepper>
</div>